import {ArrowBack, ArrowForward} from '@mui/icons-material';
import {Box, Stack, Typography} from '@mui/material';
import React from 'react';
import {INode} from './type';
import './NodeLinkTooltip.scss';

interface IBubbleTooltip {
  item: INode | null;
}

const BubbleTooltip = ({item}: IBubbleTooltip) => {
  return (
    <Box className="bubble-tooltip-container">
      <Typography
        className="typo-text label3_size"
        data-testid={`bubble-tooltip-typography`}
      >
        {item?.name}
      </Typography>
      <Box className="mail-block">
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size"
            data-testid={`bubble-tooltip-sent`}
          >
            Sent
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`bubble-tooltip-typography-sent-count-${item?.id ?? ''}`}
          >
            {item?.sentCount}
          </Typography>
        </Stack>
        <Stack className="mail-section">
          <ArrowBack className="focus-arrow" />
          <ArrowForward className="data-arrow" />
        </Stack>
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size focus-text"
            data-testid={`bubble-tooltip-total`}
          >
            Total
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`bubble-tooltip-typography-exchange-${item?.id ?? ''}`}
          >
            {item?.exchangeCount}
          </Typography>
        </Stack>
        <Stack className="mail-section">
          <ArrowForward className="focus-arrow" />
          <ArrowBack className="data-arrow" />
        </Stack>
        <Stack className="mail-section">
          <Typography
            className="typo-text label3_size"
            data-testid={`bubble-tooltip-received`}
          >
            Received
          </Typography>
          <Typography
            className="typo-text label3_size"
            data-testid={`bubble-tooltip-typography-received-${item?.id ?? ''}`}
          >
            {item?.recievedCount}
          </Typography>
        </Stack>
      </Box>
      <Typography
        className="typo-text label3_size"
        data-testid={`bubble-tooltip-these-counts-include-emails-where-the-entity-sent-to-itself-only-and-thus-may-differ-from-the-sum-of-all-connectors`}
      >
        These counts include emails where the entity sent to itself only, and
        thus may differ from the sum of all connectors.
      </Typography>
    </Box>
  );
};

export default BubbleTooltip;
